import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import AssetVideoPlayer from '../../portal/common/asset/AssetVideoPlayer';
import PlaceHolder from '../../portal/common/PlaceHolder';
const VideoWidget = ({ videoID, posterImageID, limitToPageWidth, disableSeekAhead = false, }) => {
    const store = useStore();
    console.log('videoWidget', videoID, posterImageID);
    if (!videoID) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Video" }));
    }
    const video = store.getOrLoad('asset', videoID);
    const posterImage = posterImageID ? store.getOrLoad('asset', posterImageID) : null;
    return (_jsx(Box, { sx: {
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: _jsx(AssetVideoPlayer, { asset: video, assetPoster: posterImage, showControls: true, aspectRatio: "16:9", playerStyle: { objectFit: 'fill' }, seekPosition: undefined, seekTrigger: undefined, handleNextPrevious: () => { }, onPause: () => { }, onProgress: () => { }, onEnd: () => { }, onDuration: () => { }, disableSeekAhead: disableSeekAhead }) }));
};
VideoWidget.defaultProps = {
    videoID: null,
};
VideoWidget.meta = {
    group: 'design',
    name: 'Video',
    sort: 40,
    description: 'Directly render Video.',
    props: [
        {
            key: 'videoID',
            name: 'Video',
            type: 'video', // note this is a special type recognized by the system
            description: 'The Video to display.',
        },
        {
            key: 'disableSeekAhead',
            name: 'Disable Seek Ahead',
            type: 'boolean',
            description: 'Don\'t allow fast fowarding/skipping the video.',
        },
        {
            key: 'posterImageID',
            name: 'Poster Image',
            type: 'imageAsset', // note this is a special type recognized by the system
            description: 'The Poster Image to display.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit To Max Page Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'VideoWidget',
        props: {
            limitToPageWidth: true,
            disableSeekAhead: false,
        },
    },
};
export default VideoWidget;
//# sourceMappingURL=VideoWidget.js.map